/* eslint-disable  @typescript-eslint/no-unused-vars */
import { SitecorePageProps } from 'lib/page-props';

/**
 * The Bootstrap component is the entry point for performing any initialization logic
 * that needs to happen early in the application's lifecycle.
 */
const Bootstrap = (_props: SitecorePageProps): React.JSX.Element | null => {
  return null;
};

export default Bootstrap;
